import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Card, Form, Offcanvas, Button, Image } from 'react-bootstrap';
import Layout from "../../components/Layout.";
import news from "../../actions/news";
import {ReactComponent as CupSvg} from './../../assets/icons/svg/cup.svg';
import {ReactComponent as FilterSvg} from './../../assets/icons/svg/filters.svg';
import {ReactComponent as CheckSvg} from './../../assets/icons/svg/check.svg';

export default function ArticleList() {
   const navigate = useNavigate();
   const [newsList, setNewsList] = useState([]);
   const [filter, setFilter] = useState({
      limit:"",
      filter:"",
      search: ""
   });
   const [showConfirm, setShowConfirm] = useState(false);
   const handleCloseConfirm = () => setShowConfirm(false);
   const handleShowConfirm = () => setShowConfirm(true);
   const [loading, setLoading] = useState(true);
   
   const limit_list = [
      {name:'Semua', path: ''},
      {name:'Terbaru', path: '-created_at'},
      {name:'Paling Lama', path: 'created_at'},
   ]
   const filter_list = [
      {name:'Semua', path: ''},
      {name:'Berita', path: 'news'},
      {name:'Promo', path: 'promo'},
   ]
  useEffect(() => {
   news.actions.get_news(filter.filter,filter.limit, filter.search).then((res)=>{
      setNewsList(res?.data?.data)
      setLoading(false)
   }).catch((err)=>{});
  },[])

  const getList = (pr) => {
   if(pr === 'all'){
      news.actions.get_news('','','').then((res)=>{
         setNewsList(res?.data?.data)
         setLoading(false)
         handleCloseConfirm();
      }).catch((err)=>{});
   }else{
      news.actions.get_news(filter.filter,filter.limit, filter.search).then((res)=>{
         setNewsList(res?.data?.data);
         setLoading(false)
         handleCloseConfirm();
      }).catch((err)=>{});
   }
  }

  const setSearch = (dat) => {
   setFilter({...filter, ...{search: dat}});
   getList('custom')
  }

  return (
   <Layout active={3} bg="bg-gray">
      <div className="bg-radial-green-short p-4">
        <Row className="d-flex align-items-center h-100">
          <h3 className="text-light mb-3">Berita & Promo</h3>
          <div className="d-flex align-items-center justify-content-between">
            <Form.Control placeholder="Cari berita & promo" className="me-3 search search-with-icon search-promo" 
               onKeyUp={(e) => setSearch(e.target.value)}/>
            <i className="ph-magnifying-glass search-icon"></i>
            <div onClick={() => handleShowConfirm()}><FilterSvg/></div>
          </div>
        </Row>
      </div>

      <div className="news ps-4 py-4">
         <div className="text-secondary">#Trending</div>
            {loading ? 
               <div>
                  <div className="skeleton skeleton-card"></div>
               </div>:
               <ul className="owl">
                  {newsList.map((item,key)=>{
                     return(
                        <li key={key} className={"card-news m-3 " + (key === 0 ? 'ms-4' : '')} onClick={() => navigate(`/news/${item.slug}`)}>
                           <Card>
                              <Card.Body>
                                 <Image src={item.image} width="100%" height="130px" style={{objectFit:'cover', borderRadius:'10px'}}/>
                                 <div className="fw-bold my-2 card-news-content wrap-ellipses-2">{item.title}</div>
                                 <small className="wrap-ellipses" dangerouslySetInnerHTML={{ __html: item.body }} />
                              </Card.Body>
                           </Card>
                        </li>
                     )
                  })}
               </ul>
            }
      </div>

      <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filter</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-4">

          <div className="listing mb-3">
            <div className="text-secondary mb-3">Berita & Promo</div>
            <div className="d-flex align-items-center">
              {limit_list.map((data,key)=>{
                return ( 
                <div className={'d-flex align-items-center py-2 px-3 me-2 rounded-pill' + (data.path === filter.limit ? ' btn-success text-white' : ' bg-gray')} 
                  key={key}
                  onClick={() => setFilter({...filter, ...{limit: data.path}})}
                >
                  {data.name}
                  {data.path === filter.limit ?
                    <CheckSvg className="ms-1"/> : null
                  }
                </div>
                )
              })}
            </div>
          </div>
          <div className="listing mb-3">
            <div className="text-secondary mb-3">Tipe</div>
            <div className="d-flex align-items-center">
              {filter_list.map((data,key)=>{
                return ( 
                <div className={'d-flex align-items-center py-2 px-3 me-2 rounded-pill' + (data.path === filter.filter ? ' btn-success text-white' : ' bg-gray')} 
                  key={key}
                  onClick={() => setFilter({...filter, ...{filter: data.path}})}
                >
                  {data.name}
                  {data.path === filter.filter ?
                    <CheckSvg className="ms-1"/> : null
                  }
                </div>
                )
              })}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center w-100">
              <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => getList('all')}>
                Atur Ulang
              </Button>
              <Button onClick={() => getList('custom')} className="rounded-pill py-2 w-50" variant="success">
                Terapkan
              </Button>
          </div>
         </Offcanvas.Body>
      </Offcanvas>

   </Layout>
  );
}